export enum HoursOfOperationHolidaysCondition {
    RegularHours = 0,
    Closed = 1,
    LimitedServices = 2
}
